import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Skeleton } from "@/components/ui/skeleton";
import { StatusBadge } from "@/components/StatusBadge";
import { ArtFileList } from "@/components/ArtFileList";
import { api, fmtDate, formatError } from "@/lib/api";

export default function AdminArts() {
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    api.get("/admin/arts").then((r) => setOrders(r.data)).catch((e) => { setOrders([]); toast.error(formatError(e)); });
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display text-3xl font-extrabold tracking-tight">Artes recebidas</h1>
        <p className="text-slate-500">Arquivos enviados pelos clientes em cada pedido.</p>
      </div>
      {orders === null ? (
        <Skeleton className="h-64 rounded-md" />
      ) : orders.length === 0 ? (
        <p className="rounded-md border border-dashed border-slate-300 bg-white p-10 text-center text-sm text-slate-500" data-testid="admin-no-arts">Nenhuma arte recebida ainda.</p>
      ) : (
        <div className="grid gap-4 lg:grid-cols-2" data-testid="admin-arts-list">
          {orders.map((o) => (
            <div key={o.id} className="space-y-3 rounded-md border border-slate-200 bg-white p-5" data-testid={`admin-art-order-${o.number}`}>
              <div className="flex items-start justify-between gap-3">
                <div>
                  <p className="font-mono text-lg font-bold">#{o.number}</p>
                  <p className="text-sm font-semibold">{o.customer.name}</p>
                  <p className="text-xs text-slate-500">{o.customer.email} · {o.customer.phone} · {fmtDate(o.created_at)}</p>
                </div>
                <StatusBadge status={o.status} testId={`admin-art-status-${o.number}`} />
              </div>
              <p className="text-xs text-slate-500">{o.items.map((i) => i.name).join(", ")}</p>
              {o.notes && <p className="rounded bg-slate-50 p-2 text-xs"><span className="font-semibold">Obs.:</span> {o.notes}</p>}
              <ArtFileList files={o.art_files} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
